module.exports = __webpack_public_path__ + "img/header-bg.56c2650a.png";